import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "col-content" }
const _hoisted_2 = { class: "appTitle" }
const _hoisted_3 = {
  key: 0,
  class: "smartIncompatibleNotice",
  "data-testid": "smartIncompatibleNotice"
}
const _hoisted_4 = { class: "appLogo" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "appName" }
const _hoisted_7 = { class: "appDesc" }
const _hoisted_8 = ["data-testid", "aria-label", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["AppListItem", { smartIncompatible: !_ctx.smartCompatible }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.smartCompatible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-circle-info" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('app_unavailable_in_ehr_session')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.app.iconUrl,
            alt: _ctx.pic
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.app.name), 1)
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.app.description), 1),
      _createElementVNode("button", {
        "data-testid": _ctx.app.key,
        "aria-label": `${_ctx.$t('launch')} ${_ctx.app.name}`,
        disabled: !_ctx.smartCompatible,
        class: "button",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.LoadApp()))
      }, _toDisplayString(_ctx.$t('launch')), 9, _hoisted_8)
    ])
  ], 2))
}